import store from "../store/index";
import i18n from "@/utils/translations";

let countries = () => {
  return [
    { text: "Afghanistan", value: "AF" },
    { text: "Åland Islands", value: "AX" },
    { text: "Albania", value: "AL" },
    { text: "Algeria", value: "DZ" },
    { text: "American Samoa", value: "AS" },
    { text: "Andorra", value: "AD" },
    { text: "Angola", value: "AO" },
    { text: "Anguilla", value: "AI" },
    { text: "Antarctica", value: "AQ" },
    { text: "Antigua and Barbuda", value: "AG" },
    { text: "Argentina", value: "AR" },
    { text: "Armenia", value: "AM" },
    { text: "Aruba", value: "AW" },
    { text: "Australia", value: "AU" },
    { text: "Austria", value: "AT" },
    { text: "Azerbaijan", value: "AZ" },
    { text: "Bahamas", value: "BS" },
    { text: "Bahrain", value: "BH" },
    { text: "Bangladesh", value: "BD" },
    { text: "Barbados", value: "BB" },
    { text: "Belarus", value: "BY" },
    { text: "Belgium", value: "BE" },
    { text: "Belize", value: "BZ" },
    { text: "Benin", value: "BJ" },
    { text: "Bermuda", value: "BM" },
    { text: "Bhutan", value: "BT" },
    { text: "Bolivia", value: "BO" },
    { text: "Bosnia and Herzegovina", value: "BA" },
    { text: "Botswana", value: "BW" },
    { text: "Bouvet Island", value: "BV" },
    { text: "Brazil", value: "BR" },
    { text: "British Indian Ocean Territory", value: "IO" },
    { text: "Brunei Darussalam", value: "BN" },
    { text: "Bulgaria", value: "BG" },
    { text: "Burkina Faso", value: "BF" },
    { text: "Burundi", value: "BI" },
    { text: "Cambodia", value: "KH" },
    { text: "Cameroon", value: "CM" },
    { text: "Canada", value: "CA" },
    { text: "Cape Verde", value: "CV" },
    { text: "Cayman Islands", value: "KY" },
    { text: "Central African Republic", value: "CF" },
    { text: "Chad", value: "TD" },
    { text: "Chile", value: "CL" },
    { text: "China", value: "CN" },
    { text: "Christmas Island", value: "CX" },
    { text: "Cocos (Keeling) Islands", value: "CC" },
    { text: "Colombia", value: "CO" },
    { text: "Comoros", value: "KM" },
    { text: "Congo", value: "CG" },
    { text: "Congo, The Democratic Republic of the", value: "CD" },
    { text: "Cook Islands", value: "CK" },
    { text: "Costa Rica", value: "CR" },
    { text: "Cote D'Ivoire", value: "CI" },
    { text: "Croatia", value: "HR" },
    { text: "Cuba", value: "CU" },
    { text: "Cyprus", value: "CY" },
    { text: "Czech Republic", value: "CZ" },
    { text: "Denmark", value: "DK" },
    { text: "Djibouti", value: "DJ" },
    { text: "Dominica", value: "DM" },
    { text: "Dominican Republic", value: "DO" },
    { text: "Ecuador", value: "EC" },
    { text: "Egypt", value: "EG" },
    { text: "El Salvador", value: "SV" },
    { text: "Equatorial Guinea", value: "GQ" },
    { text: "Eritrea", value: "ER" },
    { text: "Estonia", value: "EE" },
    { text: "Ethiopia", value: "ET" },
    { text: "Falkland Islands (Malvinas)", value: "FK" },
    { text: "Faroe Islands", value: "FO" },
    { text: "Fiji", value: "FJ" },
    { text: "Finland", value: "FI" },
    { text: "France", value: "FR" },
    { text: "French Guiana", value: "GF" },
    { text: "French Polynesia", value: "PF" },
    { text: "French Southern Territories", value: "TF" },
    { text: "Gabon", value: "GA" },
    { text: "Gambia", value: "GM" },
    { text: "Georgia", value: "GE" },
    { text: "Germany", value: "DE" },
    { text: "Ghana", value: "GH" },
    { text: "Gibraltar", value: "GI" },
    { text: "Greece", value: "GR" },
    { text: "Greenland", value: "GL" },
    { text: "Grenada", value: "GD" },
    { text: "Guadeloupe", value: "GP" },
    { text: "Guam", value: "GU" },
    { text: "Guatemala", value: "GT" },
    { text: "Guernsey", value: "GG" },
    { text: "Guinea", value: "GN" },
    { text: "Guinea-Bissau", value: "GW" },
    { text: "Guyana", value: "GY" },
    { text: "Haiti", value: "HT" },
    { text: "Heard Island and Mcdonald Islands", value: "HM" },
    { text: "Holy See (Vatican City State)", value: "VA" },
    { text: "Honduras", value: "HN" },
    { text: "Hong Kong", value: "HK" },
    { text: "Hungary", value: "HU" },
    { text: "Iceland", value: "IS" },
    { text: "India", value: "IN" },
    { text: "Indonesia", value: "ID" },
    { text: "Iran, Islamic Republic Of", value: "IR" },
    { text: "Iraq", value: "IQ" },
    { text: "Ireland", value: "IE" },
    { text: "Isle of Man", value: "IM" },
    { text: "Israel", value: "IL" },
    { text: "Italy", value: "IT" },
    { text: "Jamaica", value: "JM" },
    { text: "Japan", value: "JP" },
    { text: "Jersey", value: "JE" },
    { text: "Jordan", value: "JO" },
    { text: "Kazakhstan", value: "KZ" },
    { text: "Kenya", value: "KE" },
    { text: "Kiribati", value: "KI" },
    { text: "Korea, Democratic People'S Republic of", value: "KP" },
    { text: "Korea, Republic of", value: "KR" },
    { text: "Kuwait", value: "KW" },
    { text: "Kyrgyzstan", value: "KG" },
    { text: "Lao People'S Democratic Republic", value: "LA" },
    { text: "Latvia", value: "LV" },
    { text: "Lebanon", value: "LB" },
    { text: "Lesotho", value: "LS" },
    { text: "Liberia", value: "LR" },
    { text: "Libyan Arab Jamahiriya", value: "LY" },
    { text: "Liechtenstein", value: "LI" },
    { text: "Lithuania", value: "LT" },
    { text: "Luxembourg", value: "LU" },
    { text: "Macao", value: "MO" },
    { text: "Macedonia, The Former Yugoslav Republic of", value: "MK" },
    { text: "Madagascar", value: "MG" },
    { text: "Malawi", value: "MW" },
    { text: "Malaysia", value: "MY" },
    { text: "Maldives", value: "MV" },
    { text: "Mali", value: "ML" },
    { text: "Malta", value: "MT" },
    { text: "Marshall Islands", value: "MH" },
    { text: "Martinique", value: "MQ" },
    { text: "Mauritania", value: "MR" },
    { text: "Mauritius", value: "MU" },
    { text: "Mayotte", value: "YT" },
    { text: "Mexico", value: "MX" },
    { text: "Micronesia, Federated States of", value: "FM" },
    { text: "Moldova, Republic of", value: "MD" },
    { text: "Monaco", value: "MC" },
    { text: "Mongolia", value: "MN" },
    { text: "Montserrat", value: "MS" },
    { text: "Morocco", value: "MA" },
    { text: "Mozambique", value: "MZ" },
    { text: "Myanmar", value: "MM" },
    { text: "Namibia", value: "NA" },
    { text: "Nauru", value: "NR" },
    { text: "Nepal", value: "NP" },
    { text: "Netherlands", value: "NL" },
    { text: "Netherlands Antilles", value: "AN" },
    { text: "New Caledonia", value: "NC" },
    { text: "New Zealand", value: "NZ" },
    { text: "Nicaragua", value: "NI" },
    { text: "Niger", value: "NE" },
    { text: "Nigeria", value: "NG" },
    { text: "Niue", value: "NU" },
    { text: "Norfolk Island", value: "NF" },
    { text: "Northern Mariana Islands", value: "MP" },
    { text: "Norway", value: "NO" },
    { text: "Oman", value: "OM" },
    { text: "Pakistan", value: "PK" },
    { text: "Palau", value: "PW" },
    { text: "Palestinian Territory, Occupied", value: "PS" },
    { text: "Panama", value: "PA" },
    { text: "Papua New Guinea", value: "PG" },
    { text: "Paraguay", value: "PY" },
    { text: "Peru", value: "PE" },
    { text: "Philippines", value: "PH" },
    { text: "Pitcairn", value: "PN" },
    { text: "Poland", value: "PL" },
    { text: "Portugal", value: "PT" },
    { text: "Puerto Rico", value: "PR" },
    { text: "Qatar", value: "QA" },
    { text: "Reunion", value: "RE" },
    { text: "Romania", value: "RO" },
    { text: "Russian Federation", value: "RU" },
    { text: "RWANDA", value: "RW" },
    { text: "Saint Helena", value: "SH" },
    { text: "Saint Kitts and Nevis", value: "KN" },
    { text: "Saint Lucia", value: "LC" },
    { text: "Saint Pierre and Miquelon", value: "PM" },
    { text: "Saint Vincent and the Grenadines", value: "VC" },
    { text: "Samoa", value: "WS" },
    { text: "San Marino", value: "SM" },
    { text: "Sao Tome and Principe", value: "ST" },
    { text: "Saudi Arabia", value: "SA" },
    { text: "Senegal", value: "SN" },
    { text: "Serbia and Montenegro", value: "CS" },
    { text: "Seychelles", value: "SC" },
    { text: "Sierra Leone", value: "SL" },
    { text: "Singapore", value: "SG" },
    { text: "Slovakia", value: "SK" },
    { text: "Slovenia", value: "SI" },
    { text: "Solomon Islands", value: "SB" },
    { text: "Somalia", value: "SO" },
    { text: "South Africa", value: "ZA" },
    { text: "South Georgia and the South Sandwich Islands", value: "GS" },
    { text: "Spain", value: "ES" },
    { text: "Sri Lanka", value: "LK" },
    { text: "Sudan", value: "SD" },
    { text: "Suriname", value: "SR" },
    { text: "Svalbard and Jan Mayen", value: "SJ" },
    { text: "Swaziland", value: "SZ" },
    { text: "Sweden", value: "SE" },
    { text: "Switzerland", value: "CH" },
    { text: "Syrian Arab Republic", value: "SY" },
    { text: "Taiwan, Province of China", value: "TW" },
    { text: "Tajikistan", value: "TJ" },
    { text: "Tanzania, United Republic of", value: "TZ" },
    { text: "Thailand", value: "TH" },
    { text: "Timor-Leste", value: "TL" },
    { text: "Togo", value: "TG" },
    { text: "Tokelau", value: "TK" },
    { text: "Tonga", value: "TO" },
    { text: "Trinidad and Tobago", value: "TT" },
    { text: "Tunisia", value: "TN" },
    { text: "Turkey", value: "TR" },
    { text: "Turkmenistan", value: "TM" },
    { text: "Turks and Caicos Islands", value: "TC" },
    { text: "Tuvalu", value: "TV" },
    { text: "Uganda", value: "UG" },
    { text: "Ukraine", value: "UA" },
    { text: "United Arab Emirates", value: "AE" },
    { text: "United Kingdom", value: "GB" },
    { text: "United States", value: "US" },
    { text: "United States Minor Outlying Islands", value: "UM" },
    { text: "Uruguay", value: "UY" },
    { text: "Uzbekistan", value: "UZ" },
    { text: "Vanuatu", value: "VU" },
    { text: "Venezuela", value: "VE" },
    { text: "Viet Nam", value: "VN" },
    { text: "Virgin Islands, British", value: "VG" },
    { text: "Virgin Islands, U.S.", value: "VI" },
    { text: "Wallis and Futuna", value: "WF" },
    { text: "Western Sahara", value: "EH" },
    { text: "Yemen", value: "YE" },
    { text: "Zambia", value: "ZM" },
    { text: "Zimbabwe", value: "ZW" },
  ];
};

const partnerRoles = [
  { name: i18n.t("utils.constants.admin"), id: "owner", server: "ADMIN" },
  {
    name: i18n.t("utils.constants.communications"),
    id: "communications",
    server: "COMMUNICATION_MANAGER",
  },
];

const unitConversions = () => {
  return {
    "": {
      default_imperial: "",
      default_metric: "",
      transformations: [
        {
          display_name: "",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "",
          unit: "",
        },
      ],
    },
    angle_degrees: {
      default_imperial: "angle_degrees",
      default_metric: "angle_degrees",
      transformations: [
        {
          display_name: "Degrees (°)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "angle_degrees",
          unit: "°",
        },
      ],
    },
    angle_latitude_degrees: {
      default_imperial: "angle_latitude_degrees",
      default_metric: "angle_latitude_degrees",
      transformations: [
        {
          display_name: "angle_latitude_degrees",
          formatter: "latitude_formatter",
          formula: "X*1",
          id: "angle_latitude_degrees",
          unit: "",
        },
      ],
    },
    angle_longitude_degrees: {
      default_imperial: "angle_longitude_degrees",
      default_metric: "angle_longitude_degrees",
      transformations: [
        {
          display_name: "angle_longitude_degrees",
          formatter: "longitude_formatter",
          formula: "X*1",
          id: "angle_longitude_degrees",
          unit: "",
        },
      ],
    },
    angle_radians: {
      default_imperial: "angle_degrees",
      default_metric: "angle_degrees",
      transformations: [
        {
          display_name: "Degrees (°)",
          formatter: "simple_formatter",
          formula: "X*57.2958",
          id: "angle_degrees",
          unit: "°",
        },
      ],
    },
    angular_velocity_rpm: {
      default_imperial: "angular_velocity_rpm",
      default_metric: "angular_velocity_rpm",
      transformations: [
        {
          display_name: "Revolutions per minutes (rpm)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "angular_velocity_rpm",
          unit: "rpm",
        },
      ],
    },
    boolean_activated: {
      default_imperial: "boolean_activated",
      default_metric: "boolean_activated",
      transformations: [
        {
          display_name: "Activated/Off",
          formatter: "bool_formatter",
          formula: "X*1",
          id: "boolean_activated",
          unit: {
            false: "Off",
            true: "Activated",
          },
        },
      ],
    },
    boolean_connected: {
      default_imperial: "boolean_connected",
      default_metric: "boolean_connected",
      transformations: [
        {
          display_name: "Connected/Disconnected",
          formatter: "bool_formatter",
          formula: "X*1",
          id: "boolean_connected",
          unit: {
            false: "Disconnected",
            true: "Connected",
          },
        },
      ],
    },
    boolean_open: {
      default_imperial: "boolean_open",
      default_metric: "boolean_open",
      transformations: [
        {
          display_name: "Open/Closed",
          formatter: "bool_formatter",
          formula: "X*1",
          id: "boolean_open",
          unit: {
            false: "Closed",
            true: "Open",
          },
        },
      ],
    },
    boolean_power: {
      default_imperial: "boolean_power",
      default_metric: "boolean_power",
      transformations: [
        {
          display_name: "On/Off",
          formatter: "bool_formatter",
          formula: "X*1",
          id: "boolean_power",
          unit: {
            false: "Off",
            true: "On",
          },
        },
      ],
    },
    capacity_imperial_gallons: {
      default_imperial: "capacity_imperial_gallons",
      default_metric: "capacity_imperial_gallons",
      transformations: [
        {
          display_name: "Imperial gallons (gal)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "capacity_imperial_gallons",
          unit: "gal",
        },
      ],
    },
    capacity_liquid_gallons: {
      default_imperial: "capacity_liquid_gallons",
      default_metric: "capacity_liquid_gallons",
      transformations: [
        {
          display_name: "Liquid gallons (gal)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "capacity_liquid_gallons",
          unit: "gal",
        },
      ],
    },
    capacity_liters: {
      default_imperial: "capacity_liquid_gallons",
      default_metric: "capacity_liters",
      transformations: [
        {
          display_name: "Liters (l)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "capacity_liters",
          unit: "l",
        },
        {
          display_name: "Liquid gallons (gal)",
          formatter: "simple_formatter",
          formula: "X*0.2641720523",
          id: "capacity_liquid_gallons",
          unit: "gal",
        },
      ],
    },
    current_ampere: {
      default_imperial: "current_ampere",
      default_metric: "current_ampere",
      transformations: [
        {
          display_name: "Amperes (A)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "current_ampere",
          unit: "A",
        },
      ],
    },
    datestamp: {
      default_imperial: "datestamp",
      default_metric: "datestamp",
      transformations: [
        {
          display_name: "Datestamp",
          formatter: "date_formatter",
          formula: "X*1",
          id: "datestamp",
          unit: "",
        },
      ],
    },
    frequency_hz: {
      default_imperial: "frequency_hz",
      default_metric: "frequency_hz",
      transformations: [
        {
          display_name: "Hertz (Hz)",
          formatter: "isoprefix_formatter",
          formula: "X*1",
          id: "frequency_hz",
          unit: "Hz",
        },
      ],
    },
    integer: {
      default_imperial: "integer",
      default_metric: "integer",
      transformations: [
        {
          display_name: "Number",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "integer",
          unit: "",
        },
      ],
    },
    length_feet: {
      default_imperial: "length_feet",
      default_metric: "length_meters",
      transformations: [
        {
          display_name: "Meters (m)",
          formatter: "isoprefix_formatter",
          formula: "X*0.3048",
          id: "length_meters",
          unit: "m",
        },
        {
          display_name: "Feet (ft)",
          formatter: "imperial_length_formatter",
          formula: "X*1",
          id: "length_feet",
          unit: "ft",
        },
      ],
    },
    length_meters: {
      default_imperial: "length_feet",
      default_metric: "length_meters",
      transformations: [
        {
          display_name: "Feet (ft)",
          formatter: "imperial_length_formatter",
          formula: "X*3.28084",
          id: "length_feet",
          unit: "ft",
        },
        {
          display_name: "Meters (m)",
          formatter: "isoprefix_formatter",
          formula: "X*1",
          id: "length_meters",
          unit: "m",
        },
      ],
    },
    length_nautical_meters: {
      default_imperial: "length_nautical_meters",
      default_metric: "length_nautical_meters",
      transformations: [
        {
          display_name: "Nautical miles (NM)",
          formatter: "simple_formatter",
          formula: "X*0.000539957",
          id: "length_nm",
          unit: "NM",
        },
        {
          display_name: "m",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "length_nautical_meters",
          unit: "m",
        },
      ],
    },
    length_nm: {
      default_imperial: "length_nm",
      default_metric: "length_nm",
      transformations: [
        {
          display_name: "Nautical miles (NM)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "length_nm",
          unit: "NM",
        },
      ],
    },
    "millig-unit": {
      default_imperial: "millig-unit",
      default_metric: "millig-unit",
      transformations: [
        {
          display_name: "mG",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "millig-unit",
          unit: "mG",
        },
      ],
    },
    pdop: {
      default_imperial: "pdop",
      default_metric: "pdop",
      transformations: [
        {
          display_name: "PDOP (DOP)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "pdop",
          unit: "DOP",
        },
      ],
    },
    power_dbm: {
      default_imperial: "power_dbm",
      default_metric: "power_dbm",
      transformations: [
        {
          display_name: "dBm",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "power_dbm",
          unit: "dBm",
        },
      ],
    },
    power_factor_float: {
      default_imperial: "power_factor_float",
      default_metric: "power_factor_float",
      transformations: [
        {
          display_name: "power_factor_float",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "power_factor_float",
          unit: "",
        },
      ],
    },
    power_watt: {
      default_imperial: "power_watt",
      default_metric: "power_watt",
      transformations: [
        {
          display_name: "Watts (W)",
          formatter: "isoprefix_formatter",
          formula: "X*1",
          id: "power_watt",
          unit: "W",
        },
      ],
    },
    pressure_bar: {
      default_imperial: "pressure_psi",
      default_metric: "pressure_bar",
      transformations: [
        {
          display_name: "Psi",
          formatter: "simple_formatter",
          formula: "X*14.50377",
          id: "pressure_psi",
          unit: "Psi",
        },
        {
          display_name: "Bar",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "pressure_bar",
          unit: "Bar",
        },
      ],
    },
    pressure_hpa: {
      default_imperial: "pressure_hpa",
      default_metric: "pressure_hpa",
      transformations: [
        {
          display_name: "hPa",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "pressure_hpa",
          unit: "hPa",
        },
        {
          display_name: "Bar",
          formatter: "simple_formatter",
          formula: "X*0.001",
          id: "pressure_bar",
          unit: "Bar",
        },
      ],
    },
    pressure_mbar: {
      default_imperial: "pressure_psi",
      default_metric: "pressure_mbar",
      transformations: [
        {
          display_name: "Psi",
          formatter: "simple_formatter",
          formula: "X*0.0145038",
          id: "pressure_psi",
          unit: "Psi",
        },
        {
          display_name: "mBar",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "pressure_mbar",
          unit: "mBar",
        },
      ],
    },
    pressure_psi: {
      default_imperial: "pressure_psi",
      default_metric: "pressure_bar",
      transformations: [
        {
          display_name: "Psi",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "pressure_psi",
          unit: "Psi",
        },
        {
          display_name: "Bar",
          formatter: "simple_formatter",
          formula: "X*0.0689476",
          id: "pressure_bar",
          unit: "Bar",
        },
      ],
    },
    rate_gallons_per_hour: {
      default_imperial: "rate_gallons_per_hour",
      default_metric: "rate_liters_per_hour",
      transformations: [
        {
          display_name: "Liters per hour (l/h)",
          formatter: "simple_formatter",
          formula: "X*3.78541",
          id: "rate_liters_per_hour",
          unit: "l/h",
        },
        {
          display_name: "Gallons per hour (gal/h)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "rate_gallons_per_hour",
          unit: "gal/h",
        },
      ],
    },
    rate_liters_per_hour: {
      default_imperial: "rate_gallons_per_hour",
      default_metric: "rate_liters_per_hour",
      transformations: [
        {
          display_name: "Liters per hour (l/h)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "rate_liters_per_hour",
          unit: "l/h",
        },
        {
          display_name: "Gallons per hour (gal/h)",
          formatter: "simple_formatter",
          formula: "X*0.26",
          id: "rate_gallons_per_hour",
          unit: "gal/h",
        },
      ],
    },
    ratio_db: {
      default_imperial: "ratio_db",
      default_metric: "ratio_db",
      transformations: [
        {
          display_name: "dB",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "ratio_db",
          unit: "dB",
        },
      ],
    },
    ratio_partspermillion: {
      default_imperial: "ratio_partspermillion",
      default_metric: "ratio_partspermillion",
      transformations: [
        {
          display_name: "Parts per million (ppm)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "ratio_partspermillion",
          unit: "ppm",
        },
      ],
    },
    ratio_partspertrillion: {
      default_imperial: "ratio_partspertrillion",
      default_metric: "ratio_partspertrillion",
      transformations: [
        {
          display_name: "Parts per trillion (ppt)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "ratio_partspertrillion",
          unit: "ppt",
        },
      ],
    },
    reactive_power_var: {
      default_imperial: "reactive_power_var",
      default_metric: "reactive_power_var",
      transformations: [
        {
          display_name: "VAR",
          formatter: "isoprefix_formatter",
          formula: "X*1",
          id: "reactive_power_var",
          unit: "VAR",
        },
      ],
    },
    relative_humidity: {
      default_imperial: "relative_humidity",
      default_metric: "relative_humidity",
      transformations: [
        {
          display_name: "Relative humidity (%)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "relative_humidity",
          unit: "%",
        },
      ],
    },
    relative_percentage: {
      default_imperial: "relative_percentage",
      default_metric: "relative_percentage",
      transformations: [
        {
          display_name: "Percentage (%)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "relative_percentage",
          unit: "%",
        },
      ],
    },
    rssi_lookup: {
      default_imperial: "rssi_lookup",
      default_metric: "rssi_lookup",
      transformations: [
        {
          display_name: "dBm",
          formatter: "rssi_lookup_formatter",
          formula: "X*1",
          id: "rssi_lookup",
          unit: "dBm",
        },
      ],
    },
    speed_kmph: {
      default_imperial: "speed_knots",
      default_metric: "speed_knots",
      transformations: [
        {
          display_name: "Knots (kn)",
          formatter: "simple_formatter",
          formula: "X*0.539957",
          id: "speed_knots",
          unit: "kn",
        },
        {
          display_name: "Kilometre per hour (km/h)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "speed_kmph",
          unit: "km/h",
        },
      ],
    },
    speed_knots: {
      default_imperial: "speed_knots",
      default_metric: "speed_knots",
      transformations: [
        {
          display_name: "Knots (kn)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "speed_knots",
          unit: "kn",
        },
      ],
    },
    speed_mps: {
      default_imperial: "speed_knots",
      default_metric: "speed_knots",
      transformations: [
        {
          display_name: "Knots (kn)",
          formatter: "simple_formatter",
          formula: "X*1.94384",
          id: "speed_knots",
          unit: "kn",
        },
        {
          display_name: "Kilometre per hour (km/h)",
          formatter: "simple_formatter",
          formula: "X*3.6",
          id: "speed_kmph",
          unit: "km/h",
        },
      ],
    },
    temperature_celsius: {
      default_imperial: "temperature_fahrenheit",
      default_metric: "temperature_celsius",
      transformations: [
        {
          display_name: "Degrees celsius (°C)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "temperature_celsius",
          unit: "°C",
        },
        {
          display_name: "Degrees fahrenheit (°F)",
          formatter: "simple_formatter",
          formula: "X*1.8+32",
          id: "temperature_fahrenheit",
          unit: "°F",
        },
      ],
    },
    temperature_fahrenheit: {
      default_imperial: "temperature_fahrenheit",
      default_metric: "temperature_celsius",
      transformations: [
        {
          display_name: "Degrees celsius (°C)",
          formatter: "simple_formatter",
          formula: "(X - 32)*0.5556",
          id: "temperature_celsius",
          unit: "°C",
        },
        {
          display_name: "Degrees fahrenheit (°F)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "temperature_fahrenheit",
          unit: "°F",
        },
      ],
    },
    temperature_kelvin: {
      default_imperial: "temperature_fahrenheit",
      default_metric: "temperature_celsius",
      transformations: [
        {
          display_name: "Degrees celsius (°C)",
          formatter: "simple_formatter",
          formula: "X-273.15",
          id: "temperature_celsius",
          unit: "°C",
        },
        {
          display_name: "Degrees fahrenheit (°F)",
          formatter: "simple_formatter",
          formula: "X*1.8-459.67",
          id: "temperature_fahrenheit",
          unit: "°F",
        },
      ],
    },
    time_days: {
      default_imperial: "time_days",
      default_metric: "time_days",
      transformations: [
        {
          display_name: "Days (d)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "time_days",
          unit: "d",
        },
      ],
    },
    time_hours: {
      default_imperial: "time_hours",
      default_metric: "time_hours",
      transformations: [
        {
          display_name: "Hours (h)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "time_hours",
          unit: "h",
        },
      ],
    },
    time_minutes: {
      default_imperial: "time_hours",
      default_metric: "time_hours",
      transformations: [
        {
          display_name: "Minutes (m)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "time_minutes",
          unit: "min",
        },
        {
          display_name: "Days (d)",
          formatter: "simple_formatter",
          formula: "X/1440",
          id: "time_days",
          unit: "d",
        },
        {
          display_name: "Hours (h)",
          formatter: "simple_formatter",
          formula: "X/60",
          id: "time_hours",
          unit: "h",
        },
      ],
    },
    time_seconds: {
      default_imperial: "time_hours",
      default_metric: "time_hours",
      transformations: [
        {
          display_name: "Seconds (s)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "time_seconds",
          unit: "s",
        },
        {
          display_name: "Days (d)",
          formatter: "simple_formatter",
          formula: "X/86400",
          id: "time_days",
          unit: "d",
        },
        {
          display_name: "Hours (h)",
          formatter: "simple_formatter",
          formula: "X/3600",
          id: "time_hours",
          unit: "h",
        },
        {
          display_name: "Minutes (m)",
          formatter: "simple_formatter",
          formula: "X/60",
          id: "time_minutes",
          unit: "min",
        },
      ],
    },
    time_seconds_to_minutes: {
      default_imperial: "time_minutes",
      default_metric: "time_minutes",
      transformations: [
        {
          display_name: "Seconds (s)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "time_seconds",
          unit: "s",
        },
        {
          display_name: "Hours (h)",
          formatter: "simple_formatter",
          formula: "X/3600",
          id: "time_hours",
          unit: "h",
        },
        {
          display_name: "Minutes (m)",
          formatter: "simple_formatter",
          formula: "X/60",
          id: "time_minutes",
          unit: "min",
        },
      ],
    },
    time_seconds_to_seconds: {
      default_imperial: "time_seconds",
      default_metric: "time_seconds",
      transformations: [
        {
          display_name: "Seconds (s)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "time_seconds",
          unit: "s",
        },
        {
          display_name: "Hours (h)",
          formatter: "simple_formatter",
          formula: "X/3600",
          id: "time_hours",
          unit: "h",
        },
        {
          display_name: "Minutes (m)",
          formatter: "simple_formatter",
          formula: "X/60",
          id: "time_minutes",
          unit: "min",
        },
      ],
    },
    timestamp: {
      default_imperial: "timestamp",
      default_metric: "timestamp",
      transformations: [
        {
          display_name: "Timestamp",
          formatter: "datetime_formatter",
          formula: "X*1",
          id: "timestamp",
          unit: "",
        },
      ],
    },
    value_ppm: {
      default_imperial: "value_ppm",
      default_metric: "value_ppm",
      transformations: [
        {
          display_name: "ppm",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "value_ppm",
          unit: "ppm",
        },
      ],
    },
    voltage_percentage: {
      default_imperial: "voltage_percentage",
      default_metric: "voltage_percentage",
      transformations: [
        {
          display_name: "Level (%)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "voltage_percentage",
          unit: "%",
        },
      ],
    },
    voltage_volts: {
      default_imperial: "voltage_volts",
      default_metric: "voltage_volts",
      transformations: [
        {
          display_name: "Volts (V)",
          formatter: "simple_formatter",
          formula: "X*1",
          id: "voltage_volts",
          unit: "V",
        },
      ],
    },
  };
};

export default { countries, unitConversions, partnerRoles };
